/* eslint-disable no-unused-vars */

export enum CardModalFormNames {
  // Card Details
  Account = 'contractNumber',
  EmbossingName = 'embossedLastName',
  EmbossingLine = 'embossedCompanyName',
  DriverName = 'driverName',
  VehicleRegistration = 'registrationNumber',
  IssueDateFrom = 'issueDate',
  IssueDateTo = 'expiryDate',
  RenewalOption = 'renewalOption',
  CostCentreCode = 'costCentre',
  DomesticNumber = 'domesticNumber',
  RegistrationState = 'registrationState',
  VehicleDescription = 'vehicleDescription',
  // Delivery Address
  ContactFirstName = 'contactFirstName',
  ContactLastName = 'contactLastName',
  AddressLineOne = 'addressLine1',
  AddressLineTwo = 'addressLine2',
  City = 'city',
  State = 'state',
  Postcode = 'postcode',
  // Card usage options
  Favourite = 'favourite',
  VerificationMethod = 'verifyPosPrompt',
  OdometerRequired = 'odometerRequired',
  OrderNumberRequired = 'orderNumberRequired',
  MonthlyLimit = 'monthlyLimit',
  DailyLimit = 'dailyLimit',
  // Products and Services
  AllProducts = 'allProducts',
  FuelPay = 'fuelPay',
  RoadsideAssistance = 'roadsideAssist',
  VehicleType = 'vehicleType',
  RoadsideTerms = 'termsAndConditions',
  ServiceAndRepairs = 'serviceAndRepairs',
  cardFavoriteName = 'cardFavoriteName',
}

export interface DropDownOption {
  value: string;
  label: string;
}

export interface CardModalFormValues {
  [CardModalFormNames.Account]?: string;
  [CardModalFormNames.EmbossingName]?: string;
  [CardModalFormNames.EmbossingLine]?: string;
  [CardModalFormNames.DriverName]?: string;
  [CardModalFormNames.VehicleRegistration]?: string;
  [CardModalFormNames.IssueDateFrom]?: string;
  [CardModalFormNames.IssueDateTo]?: string;
  [CardModalFormNames.RenewalOption]?: string;
  [CardModalFormNames.CostCentreCode]?: string;
  [CardModalFormNames.DomesticNumber]?: string;
  [CardModalFormNames.RegistrationState]?: string;
  [CardModalFormNames.VehicleDescription]?: string;

  [CardModalFormNames.ContactFirstName]?: string;
  [CardModalFormNames.ContactLastName]?: string;
  [CardModalFormNames.AddressLineOne]?: string;
  [CardModalFormNames.AddressLineTwo]?: string;
  [CardModalFormNames.City]?: string;
  [CardModalFormNames.State]?: string;
  [CardModalFormNames.Postcode]?: string;

  [CardModalFormNames.Favourite]?: string;
  [CardModalFormNames.VerificationMethod]?: string;
  [CardModalFormNames.OdometerRequired]?: boolean;
  [CardModalFormNames.OrderNumberRequired]?: boolean;
  [CardModalFormNames.MonthlyLimit]?: string;
  [CardModalFormNames.DailyLimit]?: string;
  [CardModalFormNames.AllProducts]?: boolean;

  [CardModalFormNames.FuelPay]?: boolean;
  [CardModalFormNames.RoadsideAssistance]?: boolean;
  [CardModalFormNames.VehicleType]?: string;
  [CardModalFormNames.RoadsideTerms]?: boolean;
  [CardModalFormNames.ServiceAndRepairs]?: boolean;
  [CardModalFormNames.cardFavoriteName]?: string;
}
